<template>
  <header class="app-header navbar">
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none mobile-header"
      type="button"
      @click.prevent="mobileSidebarToggle"
    >
      <div class="userInfo">
        <span class="mobile-navbar">
          <i class="mobile-icon-out"><button
            class="logoutBtn"
            @click="logout"
          >log out</button></i>
        </span>
      </div>
    </button>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none"
      type="button"
      @click.prevent="sidebarToggle"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <button
      class="searchBtn"
      @click="goHome"
    >
      <i class="icon-home" />
      <span>LEAKBOT</span>
      <span v-if="$store.getters.roleID === Roles.ADMIN">SUPPORT</span>
      <span v-if="$store.getters.roleID === Roles.SUPER_ADMIN">SUPPORT</span>
      <span v-if="$store.getters.roleID === Roles.MAINTENANCE">INSURER</span>
      <span v-if="$store.getters.roleID === Roles.EXT_OPS">INSURER SUPPORT</span>
      <span v-if="$store.getters.roleID === Roles.DEVICE_CONFIGURATION_MANAGER">DEVICE CONFIGURATION MANAGER</span>
      <span v-if="$store.getters.roleID === Roles.INSURANCE">INSURER</span>
    </button>
    <b-nav
      is-nav-bar
      class="ml-auto"
    >
      <!-- NOTE @drew 2018-05-10 - this <li> is a temporary indicator for which roleID is currently active -->
      <li class="lbv-welcome">
        Welcome, 
        <span v-if="$store.getters.roleID === '1'">Admin</span>
        <span v-if="$store.getters.roleID === '2'">2</span>
        <span v-if="$store.getters.roleID === '3'">Maintenance Manager</span>
        <span v-if="$store.getters.roleID === '4'">Device Configuration Manager</span>
        <span v-if="$store.getters.roleID === '5'">Super Admin</span>
        <span v-if="$store.getters.roleID === '6'">6</span>
        <span v-if="$store.getters.roleID === '7'">Analytics</span>
        <span v-if="$store.getters.roleID === '8'">External Operations</span>
        <span v-if="$store.getters.roleID === Roles.INSURANCE">Insurance Manager</span>
        <span v-if="$store.getters.roleID === '9'">9</span>
        <span v-if="$store.getters.roleID === '0'">0</span>
      </li>
      <!-- NOTE @drew 2018-05-16 - commenting this out as I belive it's not required
      <b-nav-item class="d-md-down-none">
        <i class="icon-name">{{firstname}} {{lastname}}</i>
      </b-nav-item> -->
      <li>
        <button
          class="logoutBtn"
          @click="logout"
        >
          <span>Logout</span>
        </button>
      </li>
      <HeaderDropdown />
    </b-nav>
  </header>
</template>
<script>
import HeaderDropdown from './HeaderDropdown.vue'
import { mapGetters } from 'vuex'
import { EventBus } from '../../event-bus.js'
import * as Routes from '../../constants/routes'
import * as Roles from '../../constants/roles'

export default {
  name: 'Appheader',
  components: {
    HeaderDropdown
  },
  data: () => {
    return {
      menuVisible: false,
      Roles
    }
  },
  computed: {
    ...mapGetters([
      'firstname',
      'lastname'
    ])
  },
  mounted: () => {
    EventBus.$on('show-nav', () => {
      if (this.menuVisible) {
        this.sidebarToggle()
      }
    })
  },
  methods: {
    sidebarToggle (e) {
      document.body.classList.toggle('sidebar-hidden')
      this.menuVisible = !this.menuVisible
    },
    mobileSidebarToggle (e) {
      document.body.classList.toggle('sidebar-mobile-show')
    },
    logout: function () {
      this.$store.dispatch('logout')
      // this.$router.push(Routes.LOGIN)
    },
    goHome: function () {
      this.$router.push(Routes.HOME)
    }
  }
}
</script>
